<template>
  <div>
    <v-data-table
      :headers="installationPositionApplyDataTableHeaders"
      :items="installationPositionApplyItems"
      class="elevation-1 my-5 mx-5"
      :search="searchInstallationPositionApplyItems"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchInstallationPositionApplyItems"
            append-icon="mdi-magnify"
            :label="$t('quotation_item_new_install_search')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-btn color="primary" class="ml-5" @click="isShowInstallPositionApplyDialog = true">
            {{ $t('common_new') }}
          </v-btn>
        </v-toolbar>
        <v-dialog v-model="isShowInstallPositionApplyDialog" fullscreen persistent>
          <v-card>
            <v-card-title> </v-card-title>
            <v-card-text>
              <v-row v-if="editedApplyFormIndex !== -1">
                <v-btn
                  class="mx-2"
                  color="primary"
                  @click="confirmSendSign"
                  :loading="isLoadingConfirm"
                  :disabled="editedApplyForm.Status !== status.NotApplied"
                >
                  確認送簽核
                </v-btn>
                <v-btn
                  class="mx-2"
                  color="primary"
                  @click="isShowSignDialog = true"
                  :disabled="editedApplyForm.Status !== status.Pending"
                  :loading="isLoadingSign"
                  v-if="isShowSignBtn"
                >
                  簽核
                </v-btn>
                <v-dialog v-model="isShowSignDialog" persistent max-width="600px">
                  <v-card>
                    <v-card-title></v-card-title>
                    <v-card-text>
                      <ValidationObserver ref="signDialog">
                        <v-row>
                          <v-col>
                            <v-checkbox
                              v-model="isAccept"
                              label="是否接受"
                              @change="resetRejectedReason"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col v-if="!isAccept">
                            <ValidationProvider
                              name="拒絕原因"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-textarea
                                outlined
                                v-model="editedReviewForm.RejectedReason"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  拒絕原因
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </ValidationObserver>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="error" :disabled="isLoadingSign" text @click="closeSignDialog">
                        {{ $t('common_cancel') }}
                      </v-btn>
                      <v-btn color="success" :loading="isLoadingSign" text @click="signApplyForm">
                        {{ $t('common_confirm') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn
                  class="mx-2"
                  color="primary"
                  :disabled="
                    editedApplyForm.Status !== status.Approved ||
                      editedApplyForm.IsThrow ||
                      editedApplyForm.IsInvalid
                  "
                  :loading="isLoadingThrow"
                  @click="throwApplyForm"
                >
                  轉拋
                </v-btn>
                <v-btn
                  class="mx-2"
                  color="error"
                  :disabled="
                    editedApplyForm.Status !== status.Approved ||
                      editedApplyForm.IsThrow ||
                      editedApplyForm.IsInvalid
                  "
                  @click="isShowInvalidDialog = true"
                >
                  作廢
                </v-btn>
                <v-dialog v-model="isShowInvalidDialog" persistent max-width="600px">
                  <v-card>
                    <v-card-title>確定要作廢?</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col>
                          <ValidationObserver ref="invalidDialog">
                            <ValidationProvider
                              name="作廢原因"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-textarea
                                outlined
                                v-model="editedApplyForm.InvalidReason"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  作廢原因
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </ValidationObserver>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="error"
                        :disabled="isLoadingInvalid"
                        text
                        @click="closeInvalidDialog"
                      >
                        {{ $t('common_cancel') }}
                      </v-btn>
                      <v-btn
                        color="success"
                        :loading="isLoadingInvalid"
                        text
                        @click="saveShowInvalidDialog"
                      >
                        {{ $t('common_confirm') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </v-card-text>
            <v-card-text>
              <v-tabs v-model="dialogTab">
                <v-tab href="#tab-1">申請單</v-tab>
                <v-tab href="#tab-2" v-if="editedApplyForm.Status !== status.NotApplied"
                  >審核流程
                </v-tab>
                <v-tab-item value="tab-1">
                  <apply-form
                    :editedApplyFormIndex="editedApplyFormIndex"
                    :fatherEditedApplyForm="editedApplyForm"
                    :isAllTextFieldDisable="isAllTextFieldDisable"
                    :isLoading="
                      isLoadingConfirm || isLoadingSign || isLoadingThrow || isLoadingInvalid
                    "
                    @setEditedApplyFormIndex="setEditedApplyFormIndex"
                    @closeApplyForm="closeApplyForm"
                    @saveEditedApplyForm="saveEditedApplyForm"
                  />
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <review-form
                    :editedApplyFormNumber="editedApplyForm.Number"
                    :editedApplyFormStatus="editedApplyForm.Status"
                    :tab="dialogTab"
                    ref="reviewForm"
                    @getReviewApplicationForm="getReviewApplicationForm"
                    @getInstallPositionApplyList="getInstallPositionApplyList"
                    @searchInstallPositionApplyForm="searchInstallPositionApplyForm"
                  />
                </v-tab-item>
              </v-tabs>
            </v-card-text>
          </v-card>
        </v-dialog>
        <delete-dialog
          :isAllTextFieldDisable="false"
          :isLoadingSaveBtn="false"
          :isShowDeleteDialog="isShowDeleteInstallPositionApplyDialog"
          :deleteMessage="'common_delete'"
          @closeDelete="closeDeleteInstallPositionApply"
          @confirmDelete="confirmDeleteInstallPositionApply"
        />
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon small @click="isShowInstallPositionApplyDialogBtn(item)">
          <v-icon small v-if="item.Status === status.NotApplied">mdi-pencil</v-icon>
          <v-icon small v-else>mdi-eye</v-icon>
        </v-btn>
        <v-btn
          icon
          small
          @click="isShowDeleteInstallPositionApplyBtn(item)"
          v-if="item.Status === status.NotApplied"
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.Status`]="{ item }">
        {{ convertInstallPositionStatus(item.Status) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {
  HttpInstallPositionApplicationForm,
  HttpInstallPosition,
  HttpReviewApplicationForm
} from '@/js/http-Manager'
import ApplyForm from '@/components/Installposition/ApplyForm.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { InstallPositionStatus } from '@/js/InstallPositionStatus'
import ReviewForm from '@/components/Installposition/ReviewForm.vue'
export default {
  components: { ApplyForm, DeleteDialog, ReviewForm },
  props: {
    tab: {
      type: String
    }
  },
  name: 'InstallPositionApplyDataTable',
  data: () => ({
    status: InstallPositionStatus,
    installationPositionApplyItems: [],
    searchInstallationPositionApplyItems: '',
    isShowInstallPositionApplyDialog: false,
    dialogTab: 'tab-1',
    editedApplyForm: {
      Number: '',
      CreateReason: '',
      Status: 0,
      CreateBy: '',
      IsThrow: false,
      IsInvalid: false,
      InvalidBy: '',
      InvalidTime: 0,
      InvalidReason: '',
      InstallPositionItems: []
    },
    defaultApplyForm: {
      Number: '',
      CreateReason: '',
      Status: 0,
      CreateBy: '',
      IsThrow: false,
      IsInvalid: false,
      InvalidBy: '',
      InvalidTime: 0,
      InvalidReason: '',
      InstallPositionItems: []
    },
    editedApplyFormIndex: -1,
    isShowDeleteInstallPositionApplyDialog: false,
    isShowInvalidDialog: false,
    editedReviewForm: {
      Number: '',
      RejectedReason: '',
      Status: 0,
      ReviewBy: '',
      ReviewTime: 0
    },
    defaultReviewForm: {
      Number: '',
      RejectedReason: '',
      Status: 0,
      ReviewBy: '',
      ReviewTime: 0
    },
    editedReviewFormIndex: -1,
    isAllTextFieldDisable: false,
    isLoadingConfirm: false,
    isLoadingSign: false,
    isLoadingThrow: false,
    isLoadingInvalid: false,
    isAccept: true,
    isShowSignDialog: false
  }),
  async mounted () {
    await this.getInstallPositionApplyList()
  },
  watch: {
    async tab (val) {
      if (val === 'tab-2') {
        await this.getInstallPositionApplyList()
      }
    }
  },
  computed: {
    installationPositionApplyDataTableHeaders () {
      return [
        { text: '單號', align: 'start', value: 'Number' },
        { text: '申請人', align: 'start', value: 'CreateBy' },
        { text: '新增原因', align: 'start', value: 'CreateReason' },
        { text: '狀態', align: 'start', value: 'Status' },
        { text: this.$t('common_edit'), align: 'start', value: 'Edit' }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    isShowSignBtn () {
      return (
        this.editedReviewForm &&
        this.editedReviewForm.Status === this.status.Pending &&
        this.editedReviewForm.ReviewBy
      )
    }
  },
  methods: {
    async getReviewApplicationForm () {
      let response = await HttpReviewApplicationForm.GetReviewApplicationFormByNumberAndUserName({
        number: this.editedApplyForm.Number
      })
      this.editedReviewForm =
        response.status === 200
          ? JSON.parse(JSON.stringify(response.data.Data))
          : JSON.parse(JSON.stringify(this.defaultReviewForm))
    },
    convertInstallPositionStatus (val) {
      return InstallPositionStatus.InstallPositionStatusName(val)
    },
    async getInstallPositionApplyList () {
      let response = await HttpInstallPositionApplicationForm.GetAllInstallPositionApplicationForm()
      this.installationPositionApplyItems = response.status === 200 ? response.data.Data : []
    },
    setEditedApplyFormIndex (index) {
      this.editedApplyFormIndex = index
    },
    setIsShowApplyFormDialog (value) {
      this.isShowInstallPositionApplyDialog = value
    },
    closeApplyForm () {
      this.editedApplyForm = JSON.parse(JSON.stringify(this.defaultApplyForm))
      this.editedApplyFormIndex = -1
      this.isShowInstallPositionApplyDialog = false
      this.isAllTextFieldDisable = false
    },
    async saveEditedApplyForm (item) {
      if (this.editedApplyFormIndex === -1) {
        await HttpInstallPositionApplicationForm.AddInstallPositionApplicationForm(item)
      } else {
        await HttpInstallPositionApplicationForm.UpdateInstallPositionApplicationForm(item)
      }
      await this.getInstallPositionApplyList()
    },
    async isShowInstallPositionApplyDialogBtn (item) {
      this.editedApplyForm = JSON.parse(JSON.stringify(item))
      this.editedApplyFormIndex = this.installationPositionApplyItems.indexOf(item)
      this.isAllTextFieldDisable = this.editedApplyForm.Status !== this.status.NotApplied
      await this.getReviewApplicationForm()
      this.isShowInstallPositionApplyDialog = true
    },
    isShowDeleteInstallPositionApplyBtn (item) {
      this.editedApplyFormIndex = this.installationPositionApplyItems.indexOf(item)
      this.isShowDeleteInstallPositionApplyDialog = true
    },
    closeDeleteInstallPositionApply () {
      this.editedApplyFormIndex = -1
      this.isShowDeleteInstallPositionApplyDialog = false
    },
    async confirmDeleteInstallPositionApply () {
      await HttpInstallPositionApplicationForm.DeleteInstallPositionApplicationForm(
        this.installationPositionApplyItems[this.editedApplyFormIndex].Id
      )
      await this.getInstallPositionApplyList()
      this.closeDeleteInstallPositionApply()
    },
    async confirmSendSign () {
      this.isLoadingConfirm = true
      this.isAllTextFieldDisable = true
      await HttpInstallPositionApplicationForm.UpdateInstallPositionApplicationFormStatus(
        this.editedApplyForm
      )
      this.isLoadingConfirm = false
      await this.getInstallPositionApplyList()
      await this.searchInstallPositionApplyForm()
    },
    resetRejectedReason () {
      this.editedReviewForm.RejectedReason = ''
    },
    closeSignDialog () {
      this.isShowSignDialog = false
    },
    async signApplyForm () {
      const isValid = await this.$refs.signDialog.validate()
      if (isValid) {
        if (this.isAccept) {
          this.editedReviewForm.Status = this.status.Approved
        } else {
          this.editedReviewForm.Status = this.status.Rejected
        }
        this.isLoadingSign = true
        await HttpReviewApplicationForm.UpdateReviewApplicationFormStatus(this.editedReviewForm)
        this.isLoadingSign = false
        await this.getInstallPositionApplyList()
        await this.$refs.reviewForm.getReviewList()
        await this.searchInstallPositionApplyForm()
        this.closeSignDialog()
      }
    },
    async throwApplyForm () {
      this.isLoadingThrow = true
      this.editedApplyForm.IsThrow = true
      await HttpInstallPosition.AddInstallPositionFromApplicationForm(this.editedApplyForm)
      this.isLoadingThrow = false
      await this.getInstallPositionApplyList()
      await this.searchInstallPositionApplyForm()
    },
    closeInvalidDialog () {
      this.isShowInvalidDialog = false
    },
    async saveShowInvalidDialog () {
      const isValid = await this.$refs.invalidDialog.validate()
      if (isValid) {
        this.isLoadingInvalid = true
        this.editedApplyForm.IsInvalid = true
        await HttpInstallPositionApplicationForm.UpdateInvalid(this.editedApplyForm)
        this.isLoadingInvalid = false
        await this.getInstallPositionApplyList()
        await this.searchInstallPositionApplyForm()
        this.closeInvalidDialog()
      }
    },
    async searchInstallPositionApplyForm () {
      let response = await HttpInstallPositionApplicationForm.GetInstallPositionApplicationFormByNumber(
        {
          number: this.editedApplyForm.Number
        }
      )
      this.editedApplyForm =
        response.status === 200
          ? JSON.parse(JSON.stringify(response.data.Data))
          : JSON.parse(JSON.stringify(this.defaultApplyForm))
    }
  }
}
</script>
